class DrvRxlVideo extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.drv-rxl-vid__toggle');
    this.video = this.querySelector('video');
    if (!this.btn || !this.video) return;
    this.btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.video.paused) {
        this.video.play();
        this.classList.remove('is-paused');
        this.label('labelPause');
      } else {
        this.video.pause();
        this.classList.add('is-paused');
        this.label('labelPlay');
      }
    });
  }

  label(name) {
    const text = this.btn.dataset[name];
    if (text) this.btn.setAttribute('aria-label', text);
  }
}

if (!customElements.get('drv-rxl-video')) {
  customElements.define('drv-rxl-video', DrvRxlVideo);
}
